export const removeSpecialCharacters = (input) => {
    return input.replace(/\W/g, '').trim();
};
